<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th colspan="2" class="text-center">{{boolTitle}}</th>
          <th v-if="windowWidth > 600">&nbsp;</th>
          <th v-if="windowWidth > 600">&nbsp;</th>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <th style="width:150px;">{{objectTitle}}</th>
          <th class="text-center">
            <v-btn color="primary" small block flat @click="checkAll">JA</v-btn>
          </th>
          <th class="text-center">
            <v-btn color="primary" small block flat @click="checkNone">NEI</v-btn>
          </th>
          <th v-if="windowWidth > 600">Beløp</th>
          <th v-if="windowWidth > 600" style="width:180px;">{{commentTitle}}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in items">
          <tr :class="item.active ? 'active' : 'inactive'" :key="index+'1'">
            <td>
              <v-switch color="primary" v-model="item.active" @change="updateActive(item)" label></v-switch>
            </td>
            <td class="objectTitle">{{item.title}}</td>
            <td class="text-center radio">
              &nbsp;&nbsp;&nbsp;
              <p-radio
                class="p-icon p-curve p-plain p-tada"
                :name="'boolean_'+id+'_'+index"
                :value="1"
                color="success-o"
                :checked="item.value == 1"
                v-on:change="radioChanged"
                v-model="item.value"
                :disabled="item.active ? false : true"
              >
                <i slot="extra" class="icon mdi mdi-chevron-down-circle-outline"></i>
              </p-radio>
            </td>
            <td class="text-center radio">
              &nbsp;&nbsp;&nbsp;
              <p-radio
                class="p-icon p-curve p-plain p-tada"
                :name="'boolean_'+id+'_'+index"
                :value="0"
                color="danger-o"
                :checked="item.value == 0"
                v-on:change="radioChanged"
                v-model="item.value"
                :disabled="item.active ? false : true"
              >
                <i slot="extra" class="icon mdi mdi-alpha-x-circle-outline"></i>
              </p-radio>
            </td>
            <td v-if="windowWidth > 600">
              <v-text-field
                type="number"
                suffix="NOK"
                solo
                hide-details
                label="Beløp"
                :disabled="item.active ? false : true"
                v-model="item.cost"
              ></v-text-field>
            </td>
            <td v-if="windowWidth > 600">
              <v-text-field
                solo
                hide-details
                :label="commentTitle"
                :disabled="item.active ? false : true"
                clearable
                v-model="item.comment"
              ></v-text-field>
            </td>
          </tr>
          <tr
            :class="item.active ? 'active' : 'inactive'"
            v-if="windowWidth <= 600"
            :key="index+'3'"
          >
            <td colspan="4">
              <v-text-field
                type="number"
                suffix="NOK"
                solo
                hide-details
                label="Beløp"
                :disabled="item.active ? false : true"
                v-model="item.cost"
              ></v-text-field>
            </td>
          </tr>
          <tr
            :class="item.active ? 'active' : 'inactive'"
            v-if="windowWidth <= 600"
            :key="index+'4'"
          >
            <td colspan="4">
              <v-text-field
                solo
                hide-details
                :label="commentTitle"
                :disabled="item.active ? false : true"
                clearable
                v-model="item.comment"
              ></v-text-field>
            </td>
          </tr>
          <tr
            v-if="typeof item.relatedValue !== 'undefined'"
            :class="item.active ? 'active' : 'inactive'"
            :key="index+'5'"
            :style="item.relatedValue === 1 ? 'border: 1px solid green' : 'border: 1px solid red'"
          >
            <td colspan="2">Fra innflyttingsprotokoll</td>
            <td v-if="item.relatedValue == 1" class="text-center radio">
              &nbsp;&nbsp;&nbsp;
              <p-radio
                class="p-icon p-curve p-plain p-tada"
                :name="'boolean_related_'+id+'_'+index"
                :value="1"
                color="success-o"
                :checked="item.relatedValue == 1"
                v-model="item.relatedValue"
                :disabled="true"
              >
                <i slot="extra" class="icon mdi mdi-chevron-down-circle-outline"></i>
              </p-radio>
            </td>
            <td v-else>&nbsp;</td>
            <td v-if="item.relatedValue == 0" class="text-center radio">
              &nbsp;&nbsp;&nbsp;
              <p-radio
                class="p-icon p-curve p-plain p-tada"
                :name="'boolean_related_'+id+'_'+index"
                :value="0"
                color="danger-o"
                :checked="item.relatedValue == 0"
                v-model="item.relatedValue"
                :disabled="true"
              >
                <i slot="extra" class="icon mdi mdi-alpha-x-circle-outline"></i>
              </p-radio>
            </td>
            <td v-else>&nbsp;</td>
            <td v-if="windowWidth > 600">{{item.relatedCost}}</td>
            <td v-if="windowWidth > 600">{{item.relatedComment}}</td>
            <td v-else>&nbsp;</td>
          </tr>
          <tr
            :class="item.active ? 'active' : 'inactive'"
            v-if="windowWidth <= 600 && item.relatedCost"
            :key="index+'6'"
            style="border: 1px solid orange"
          >
            <td colspan="4">{{item.relatedCost}}</td>
          </tr>
          <tr
            :class="item.active ? 'active' : 'inactive'"
            v-if="windowWidth <= 600 && item.relatedComment"
            :key="index+'6'"
            style="border: 1px solid orange"
          >
            <td colspan="4">{{item.relatedComment}}</td>
          </tr>
          <tr :key="index+'7'">
            <td
              colspan="4"
              v-if="windowWidth <= 600"
              style="padding-bottom: 25px; padding-top: 10px"
            >
              <v-divider></v-divider>
            </td>
            <td colspan="6" v-else style="padding-bottom: 25px; padding-top: 10px">
              <v-divider></v-divider>
            </td>
          </tr>
        </template>
        <tr>
          <td colspan="4">
            <v-btn color="primary" @click="newDialog=true" class="mb-4 mt-2">Legg til</v-btn>
          </td>
        </tr>
        <tr v-if="windowWidth <= 600">
          <td colspan="4" style="padding-bottom: 25px; padding-top: 10px">
            Total SUM:
            <v-text-field
              type="number"
              suffix="NOK"
              solo
              hide-details
              label="Total SUM"
              v-model="totalSum"
              disabled
            ></v-text-field>
          </td>
        </tr>
        <tr v-else class="mt-2">
          <td colspan="4" style="padding-top:20px;" class="text-right">
            <h4>Total SUM: </h4>
          </td>
          <td colspan="2">
            <v-text-field
              type="number"
              suffix="NOK"
              solo
              hide-details
              label="Total SUM"
              v-model="totalSum"
              disabled
            ></v-text-field>
          </td>
        </tr>
      </tbody>
    </table>
    <v-dialog v-model="newDialog" max-width="500px" :dark="dark">
      <v-card>
        <v-card-title>
          <span class="headline">Legg til {{objectTitle}}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Tittel" clearable v-model="newObject.title"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="newDialog=false">Avbryt</v-btn>
          <v-btn color="primary" flat @click="createNewObject">Lagre</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  props: ["value", "objectTitle", "boolTitle", "commentTitle", "relatedVmodel"],
  data() {
    return {
      id: null,
      newDialog: false,
      newObject: { title: "", active: true, value: -1 },
      windowWidth: window.innerWidth
    };
  },
  mounted() {
    this.id = this._uid;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {
    radioChanged: function(event) {},
    updateActive(item) {
      //item.value = -1;
      //item.comment = '';
    },
    openNewDialog() {
      this.newDialog = true;
    },
    createNewObject() {
      this.value.push(this.newObject);
      this.newObject = { title: "", active: true, value: -1 };
      this.newDialog = false;
    },
    checkAll() {
      this.value.forEach(function(item) {
        item.value = 1;
      });
    },
    checkNone() {
      this.value.forEach(function(item) {
        item.value = 0;
      });
      this.value = this.value;
    }
  },
  computed: {
    dark: {
      get() {
        if (this.$store.state.fields.dark) {
          return this.$store.state.fields.dark;
        }
        return false;
      }
    },
    items: {
      get() {
        let items = [];
        for (let item in this.value) {
          items.push(this.value[item]);
        }
        if (this.relatedVmodel != null && this.relatedVmodel != undefined) {
          for (let i in items) {
            for (let relatedItem in this.relatedVmodel) {
              if (this.relatedVmodel[relatedItem].id == items[i].id) {
                if (!items[i].loadedFromRelated) {
                  items[i].value = this.relatedVmodel[relatedItem].value;
                  items[i].comment = this.relatedVmodel[relatedItem].comment;
                  items[i].loadedFromRelated = true;
                }
                items[i].relatedValue = this.relatedVmodel[relatedItem].value;
                items[i].relatedComment = this.relatedVmodel[
                  relatedItem
                ].comment;
                items[i].relatedCost = this.relatedVmodel[relatedItem].cost;
              }
            }
          }
        }
        return items;
      }
    },
    totalSum() {
      let sum = 0;
      if (this.items.length > 0) {
        for (let item in this.items) {
          if(this.items[item].active) {
            sum += isNaN(parseInt(this.items[item].cost)) ? 0 : parseInt(this.items[item].cost);
          }
        }
      }
      return sum;
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td,
table th {
  padding: 3px;
  font-size: 1rem;
}
table tr.inactive {
  background-color: lightgrey;
}
.theme--dark table tr.inactive {
  background-color: black;
}

table tr.inactive .objectTitle {
  text-decoration: line-through;
}
table .radio {
  font-size: 2rem;
}
hr {
  margin-top: 0;
  margin-bottom: 0;
}
</style>